import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from 'material-ui/Button';
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle, } from 'material-ui/Dialog';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';
import { CircularProgress } from 'material-ui/Progress';
import Slide from 'material-ui/transitions/Slide';

import find from 'lodash/find'

import * as publish from '../../../actions/meetingdetails';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

class Publish extends Component {
    state = {
        status: 'Publish'
    };

    handleChange = event => {
        this.setState({ status: event.target.value });
    };
    handleRequestClose = () => {
        this.props.closeDialog();
        this.setState({ status: 'Publish' });
    };

    setData = () => {
        // this.props.closeDialog();
        this.props.actions.updateMeetingStatusDetails(this.props.id, this.state.status);
        // this.setState({ status: 'Publish' });
    };

    render() {
        const { id, meetingDetails } = this.props;
        let result = null;
        if (meetingDetails && meetingDetails.Status) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        let _GrantList = null
        // console.log('Grant id', id)
        if (id) {
            _GrantList = ['Publish', 'Draft'].map(id => (
                <MenuItem key={id} value={id}
                    style={{ fontWeight: '500' }}>
                    {id}
                </MenuItem>
            ))
        }
        return (
            <div>
                <Dialog open={this.props.open} transition={Slide} onClose={this.handleRequestClose}>
                    <DialogTitle className="bg-primary">
                        <span className="text-white">Update Meeting Status</span>
                    </DialogTitle>
                    <DialogContent>
                        {result}
                        <div className="row p-4">
                            <div className="col-md-12">
                            Please Select the Status
                                {/* Please select the required status and update the status */}

                                <FormControl className="w-100 mt-4">
                                    <InputLabel htmlFor="age-simple">
                                        {/* Status To be Updated */}
                                    
                                    </InputLabel>
                                    <Select key="meetingStatusUpdate"
                                        value={this.state.status}
                                        onChange={this.handleChange}
                                        // onClick={(e) => this.setState({age: e.target.value})}
                                        input={<Input id="age-simple" />}

                                    >
                                        {_GrantList}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleRequestClose} variant="raised" className="jr-btn bg-grey text-white">Cancel</Button>
                        <Button onClick={this.setData} variant="raised" className="jr-btn bg-primary text-white">Publish</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return state
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(publish, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Publish);


// WEBPACK FOOTER //
// ./app/meetingdetails/meetinglist/publish.js